// extracted by mini-css-extract-plugin
export default {"clearIcon":"styles_clearIcon__0sZU4"};